import React from 'react';
import ReactDOM from 'react-dom/client';
import {CometChat} from '@cometchat/chat-sdk-javascript'
import { CometChatUIKit } from "@cometchat/chat-uikit-react";
import { UIKitSettingsBuilder } from '@cometchat/uikit-shared';
import { metaInfo } from "./metaInfo";
import App from './App';
import "@cometchat/uikit-elements";
import './index.css';
import "./index.css";

(async () => {
  const uiKitSettings = new UIKitSettingsBuilder()
  .setAppId(process.env.REACT_APP_APP_ID)
  .setRegion(process.env.REACT_APP_REGION)
  .setAuthKey(process.env.REACT_APP_AUTH_KEY)
  .subscribePresenceForAllUsers()
  .build();
  try {
    await CometChatUIKit.init(uiKitSettings);
    try{CometChat.setDemoMetaInfo(metaInfo)}catch(err){}
    console.log("CometChat Initialization completed");
    const root = ReactDOM.createRoot(document.getElementById("root"));
    root.render(<App />);
  }
  catch(error) {
    console.log("CometChat Initialization failed with error:", error);
  }
})();
